import { useCallback, useState } from "react";

// Same key map.html used — previously hidden rows stay hidden.
const HIDDEN_KEY = "dealEngineHidden";

const load = (): Set<string> => {
  try {
    const stored = JSON.parse(localStorage.getItem(HIDDEN_KEY) ?? "[]");
    return new Set(Array.isArray(stored) ? stored : []);
  } catch {
    return new Set();
  }
};

const persist = (keys: Set<string>) => {
  try {
    localStorage.setItem(HIDDEN_KEY, JSON.stringify([...keys]));
  } catch {
    // non-fatal
  }
};

/** Per-row ✕ hide, persisted across sessions ("kind:id" keys). */
export const useHiddenLeads = () => {
  const [hidden, setHidden] = useState<Set<string>>(load);

  const hide = useCallback((key: string) => {
    setHidden((prev) => {
      const next = new Set(prev);
      next.add(key);
      persist(next);
      return next;
    });
  }, []);

  const unhideAll = useCallback(() => {
    setHidden(() => {
      const next = new Set<string>();
      persist(next);
      return next;
    });
  }, []);

  return { hidden, hide, unhideAll };
};
